import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientLoginFlowImageUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getImage(req);
    }
}
export default ClientLoginFlowImageUseCase;
